import React, { ReactNode, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormType } from '../Documents'
import { DocumentType } from 'src/types'
import clsx from 'clsx'
import { InputField } from 'src/components/UI'
import { useTranslation } from 'react-i18next'
import { Close, PenIcon } from 'src/icons/icons'
import { createFileURL } from 'src/utils/new'


export const EachDoc = ({ record, mode: pageMode, status }: { record: DocumentType & { index: number }, mode: string | null, status: "error" | "idle" | "loading" | "success" }) => {


    const { index, title, type, id, is_optional, key, is_creditable } = record

    const { register, formState: { errors }, watch, setValue } = useFormContext<FormType>()

    const { t } = useTranslation()

    const [mode, setMode] = useState<'VIEW' | 'EDIT'>(pageMode == 'add' ? 'EDIT' : 'VIEW')




    const DeleteWrapper = ({ children, id }: { children: ReactNode, id: string }) => <div className='flex flex-row gap-4 items-center text-sm'>
        {children}
        <div onClick={() => setValue(`${id}.file`, '')} className='cursor-pointer'><Close color='red' /></div>
    </div>

    const PreviewComponent = ({ id, title, is_optional }: DocumentType) => {

        const targetFile = watch(`${id}`)


        if (typeof targetFile?.file == 'string' && targetFile.file?.length > 1)
            return <DeleteWrapper id={id}><button className='bg-primary-300 rounded-lg text-white flex flex-row gap-2 items-center p-2' onClick={() => window.open(createFileURL(targetFile?.file as string))} type='button'>{t('see')}</button></DeleteWrapper>

        else if (targetFile?.file instanceof FileList && targetFile.file?.[0]) {
            return <DeleteWrapper id={id}><button className='bg-primary-300 rounded-lg text-white flex flex-row gap-2 items-center p-2' onClick={() => window.open(URL.createObjectURL(targetFile?.file[0] as Blob))} type='button'>{t('seeSelectedFile')}</button></DeleteWrapper>

        }

        return <input type='file' id={`doc-${id}`} {...register(`${id}.file`, { deps: [`${id}.doc_number`, `${id}.expire_date`], required: { value: !!watch(`${id}.doc_number`) || !!watch(`${id}.expire_date`), message: `${t('File')} ${title} ${t('IsRequired')}` } })} />

    }



    useEffect(() => {
        if (status == 'success')
            setMode('VIEW')
    }, [status])
    return (
        <div className={clsx('border rounded-lg flex flex-col lg:flex-row  gap-4 lg:gap-10 lg:items-center p-3 bg-white justify-between flex-wrap', !!errors?.[`${id}`] && 'border-red')}>

            <div className='flex flex-row gap-4 lg:gap-8 items-center flex-1  '>
                <div className='bg-primary-300 rounded-full  p-2 aspect-square shrink-0 w-8 h-8 flex flex-row justify-center items-center text-white'>
                    {record.index + 1}
                </div>

                <span className=' text-center'>{title}</span>
            </div>

             {!!is_creditable && <div className={'flex flex-row gap-8 items-center flex-1 justify-between'} >


                  <div className='flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between flex-1'>



                 

                        {mode == 'VIEW' ?
                            <span className='p-2 items-center flex flex-row gap-2 text-sm'>
                                <span className='text-gray-500'>{t('number')}:</span>
                                <span>{!!watch(`${id}.doc_number`) ? watch(`${id}.doc_number`) : '-'}</span>
                            </span>
                            :
                            <InputField
                                label={`${t('number')} (${t('Optional')})`}
                                {...register(`${id}.doc_number`)}
                            // className='w-32'

                            />}


                        {mode == 'VIEW' ?
                            <span className='p-2 items-center flex flex-row gap-2 justify-between text-sm'>
                                <span className='text-gray-500'>{t('ExpireDate')}:</span>
                                <span> {!!watch(`${id}.expire_date`) ? watch(`${id}.expire_date`) : '-'}</span>
                            </span>
                            :
                            <InputField
                                label={`${t('ExpireDate')} (${t('Optional')})`}
                                {...register(`${id}.expire_date`)}
                                // className='w-32'
                                type='date'
                                style={{ display: 'ltr' }}
                            />}
                    
                    <div className='flex flex-row gap-2 cursor-pointer' onClick={() => setMode('EDIT')}>
                        {mode == 'EDIT' ? <></> : <PenIcon className='text-blue-500 size-4 cursor-pointer' />}
                    </div>

                </div>




             </div>
            }
            <div className='flex-1 flex flex-row justify-end items-center gap-2'>

                {!!errors?.[`${id}`]?.file && <span className='text-red text-sm text-center whitespace-nowrap'>{errors?.[`${id}`]?.file?.message}</span>}
                <PreviewComponent {...record} />
            </div>




        </div>
    )
}
